import { dew as _AbstractMergeDateRangeRefinerDew } from "../../../common/refiners/AbstractMergeDateRangeRefiner";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractMergeDateRangeRefiner_1 = __importDefault(_AbstractMergeDateRangeRefinerDew());
  class DEMergeDateRangeRefiner extends AbstractMergeDateRangeRefiner_1.default {
    patternBetween() {
      return /^\s*(bis(?:\s*(?:am|zum))?|-)\s*$/i;
    }
  }
  exports.default = DEMergeDateRangeRefiner;
  //# sourceMappingURL=DEMergeDateRangeRefiner.js.map
  return exports;
}